/**
 * そのページに対する承認タイプ
 * showPromote の場合のみ 権限不足で課金を促すダイアログを出す
 * hidePromote 表示後にダイアログを消した状態
 */
type pageAuthorizeType = undefined | "noLogin" | "authorized" | "showPromote" | "hidePromote";
export const usePromotePaymentDialogState = () => useState<pageAuthorizeType>("usePromotePaymentDialog", () => undefined);
